export default {"src":"/_next/static/media/check-ring-round.80a8698a.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};